import script from "./SkillBusinesstypeConfirmView.vue?vue&type=script&lang=ts&setup=true"
export * from "./SkillBusinesstypeConfirmView.vue?vue&type=script&lang=ts&setup=true"

import "./SkillBusinesstypeConfirmView.vue?vue&type=style&index=0&id=88832878&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/jobs/MASSMEDIAN_MYPAGE_VIEW_PROD/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-88832878"]])

export default __exports__